
import React from 'react';
import { useSelector } from 'react-redux';
import DashboardActive from "../images/Dashboard-Black.png";
import DashboardInActive from "../images/Dashboard-Black.png";
import ReportActive from "../images/Report-Black.png";
import ReportInnactive from "../images/Report-Black.png";
import SupportCenterActive from "../images/SupportCenter-Black.png";
import SupportCenterInActive from "../images/SupportCenter-Black.png";
import InfoActive from "../images/Info-Black.png";
import InfoInActive from "../images/Info-Gray.png";
import Logo from "./Logo";
import { useNavigate } from 'react-router-dom';
// import utils from "./filters/utils";

const NavLink = require('react-router-dom').NavLink;

function BottomNav(props) {
  const history = useNavigate();
  let role = "";
  const authObj = useSelector(state => state.auth);
  const { user, superAdmin, role: roleName } = authObj;
  if (roleName !== 'SUPERADMIN') {
    role = user && user.role;
  } else {
    if (superAdmin.isViewChanged === true) {
      role = user && user.role;
    } else {
      role = superAdmin.user && superAdmin.user.role;
    }
  }
  let lowerCaseRole = role && role.toLowerCase();
  if (lowerCaseRole === 'superadmin') {
    lowerCaseRole = "shp";
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  };

  const openMenu = () => {
    const dimensions = getWindowDimensions();
    if (dimensions.width >= 1024) {
      history.push(`/`);
    } else {
      document.body.classList.add('side-open');
      props.openSideBar(true);
    }
  };
  return (
    <nav className="bottom-nav">
      <div className="d-flex align-items-center justify-content-between">
        {/* <div className="">
          <NavLink exact activeClassName="active-link" to="/" className="p-3">
            <img src={DashboardActive} width="32" height="32" alt="Dashboard" className="img-fluid" />
          </NavLink>
        </div> */}
        <div className="">
          <NavLink exact activeClassName="active-link" to="/reports-and-analytics" className="p-3">
            <img src={ReportActive} width="32" height="32" alt="Analytics" className="img-fluid" />
          </NavLink>
        </div>
        <div className="circle">
          <span className="active" onClick={openMenu}>
            <Logo width={50} />
          </span>
        </div>
        <div className="">
          <NavLink exact activeClassName="active-link" to="/support-center" className="p-3">
            <img src={SupportCenterActive} width="32" height="32" alt="Threshold" className="img-fluid" />
          </NavLink>
        </div>
        {/* <div className="">
          <NavLink exact activeClassName="active-link" to="/profile" className="p-3">
            <img src={InfoActive} width="32" height="32" alt="Organization" className="img-fluid" />
          </NavLink>
        </div> */}
      </div>
    </nav>
  );
}
export default BottomNav;